/** `||`, not `??`: OPUS can store an empty Reference, which must fall through like a missing one. */
export function environmentLabel(env) {
    return env.reference || env.type || String(env.id);
}
